// ENTITY fr.gestionpial.user.dto.UserLiteDTO generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class UserLiteDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.user.dto.UserLiteDTO';

  idUser: number | null = 0;
  firstName: string | null = '';
  lastName: string | null = '';
  email: string | null = '';

  constructor(init?:Partial<UserLiteDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.user.dto.UserLiteDTO'] = UserLiteDTO;

fields['fr.gestionpial.user.dto.UserLiteDTO']  = {
    idUser: 'java.lang.Integer',
    firstName: 'java.lang.String',
    lastName: 'java.lang.String',
    email: 'java.lang.String'
};
